<div 
  *ngIf="success"
  class="broker-confirm-wrapper"
>
  <div class="frame">
    <div class="title">
      {{ 'BROKER-CONFIRMATION.SUCCESS.TITLE' | translate }}
    </div>
    <div class="text">
      <div>{{ 'BROKER-CONFIRMATION.SUCCESS.TEXT-1' | translate }}</div>
      <div>{{ 'BROKER-CONFIRMATION.SUCCESS.TEXT-2' | translate }}</div>
    </div>
    <dx-button
      class="login-button"
      [text]="'BROKER-CONFIRMATION.GO-TO-LOGIN-PAGE' | translate"
      type="normal"
      (click)="onLoginClick()">
    </dx-button>
  </div>
</div>

<div 
  *ngIf="error"
  class="broker-confirm-wrapper"
>
  <div class="frame">
    <div class="title">
      {{ 'BROKER-CONFIRMATION.ERROR.TITLE' | translate }}
    </div>
    <div class="text">
      {{ 'BROKER-CONFIRMATION.ERROR.TEXT' | translate }}
    </div>
  </div>
</div>